import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  // props: ['options'],
  data () {
    return {
      options: {
        legend: {
          display: false
        },
        tooltips: {
          bodyFontFamily: "'Dosis', 'Helvetica', 'Arial', sans-serif",
          bodyFontSize: 15,
          titleFontSize: 17,
          padding: 15,
          cornerRadius: 6
        }
      }
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}
